import angular from 'angular';
import boxTextTemplate from './box-text-template.component';
import BoxTextTemplateService from './box-text-template.service';
import boxTextTemplateConfig from './box-text-template.config'

let textBoxTemplateModule = angular.module('app.boxtTextTemplate',[])
    .component('boxTextTemplate', boxTextTemplate)
    .service('BoxTextTemplateService', BoxTextTemplateService)
    .config(boxTextTemplateConfig);

export default textBoxTemplateModule;



// WEBPACK FOOTER //
// ./www/components/box-text-template/box-text-template.js